<template>
  <CCard>
    <CCardHeader>
      <h2>{{ isEdit ? 'Edit Subscription' : 'Add Subscription' }}</h2>
    </CCardHeader>
    <CCardBody>
      <CForm @submit.prevent="saveSubscription">
        <CInput
          v-model="form.starts_at"
          label="Start Date"
          type="date"
          :add-input-classes="{ 'is-invalid': hasError('starts_at') }"
          :invalid-feedback="getError('starts_at')"
        />
        <CInput
          v-model="form.ends_at"
          label="End Date"
          type="date"
          :add-input-classes="{ 'is-invalid': hasError('ends_at') }"
          :invalid-feedback="getError('ends_at')"
        />
        <div class="mt-3 text-right">
          <CButton
            type="submit"
            color="primary"
          >
            {{ isEdit ? 'Update' : 'Add' }}
          </CButton>
          <CButton
            type="button"
            color="secondary"
            class="ml-2"
            @click="goBack"
          >
            Cancel
          </CButton>
        </div>
      </CForm>
    </CCardBody>
  </CCard>
</template>

<script>
import hasApiValidation from "@/mixins/hasApiValidation";

export default {
  name: "GymSubscriptionForm",
  mixins: [hasApiValidation],
  data() {
    return {
      gymId: null,
      subscriptionId: null,
      form: {
        starts_at: '',
        ends_at: ''
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.subscriptionId;
    }
  },
  mounted() {
    this.gymId = this.$route.params.gymId;
    this.subscriptionId = this.$route.params.subscriptionId || null;

    if (this.isEdit) {
      this.fetchSubscription();
    }
  },
  methods: {
    fetchSubscription() {
    this.$http.get(`/gym/${this.gymId}/gym-subscriptions`)
        .then(({ data }) => {
          const sub = data.subscriptions.find(s => s.id == this.subscriptionId);
          if (sub) {
            this.form = {
              starts_at: sub.starts_at ? this.formatForDateInput(sub.starts_at) : '',
              ends_at: sub.ends_at ? this.formatForDateInput(sub.ends_at) : ''
            };
          }
        });
    },
    formatForDateInput(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    saveSubscription() {
      this.setErrors({});
      const endpoint = this.isEdit
        ? `/gym/${this.gymId}/gym-subscriptions/${this.subscriptionId}`
        : `/gym/${this.gymId}/assign-manual-subscription`;
      const method = this.isEdit ? 'put' : 'post';

      this.$http[method](endpoint, this.form)
        .then(() => {
          this.$toast.success(this.isEdit ? 'Subscription updated!' : 'Subscription added!');
          this.goBack();
        })
        .catch(({ response }) => {
          if (response.status === 422 && response.data.errors) {
            this.setErrors(response.data.errors);
          } else {
            this.$toast.error(response.data.message || 'Failed to save subscription.');
          }
        });
    },
    goBack() {
      this.$router.push(`/gyms/${this.gymId}/subscriptions`);
    }
  }
};
</script>
